import { Metamodel } from '../base/model';
import { IAttribute, IModel } from '../base/annotation';
import { NativeMongoDbLinkedService } from 'app/model/linkedservice/native-mongo-db.linkedservice';
import { TabularTypeDataset } from 'app/model/dataset/tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { sanitizeAndFormatString, stringIsNullOrEmpty, type IVersioningDataset } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.mongoDb.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.MongoDb_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.MongoDb_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: NativeMongoDbLinkedService.MODEL // Linked service redefined
        }
    }
})
export class NativeMongoDbDataset extends TabularTypeDataset implements IVersioningDataset  {
    public static readonly MODEL: IModel;
    public static DATABASE: IAttribute;
    public static VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE',
        constraint: {
            validator: (dataset: NativeMongoDbDataset, database: string) => {
                if (__IS_FABRIC_DPE__ && stringIsNullOrEmpty(database)) {
                    return [
                        {
                            context: dataset,
                            messageType: 'missing',
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.RequiredTemplate,
                                    stringResources.Database
                                )
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        templatable: true,
        association: 'VERSION'
    })
    public version: string = __IS_FABRIC_DPE__ ? '1.1' : undefined;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
